import { render, staticRenderFns } from "./CardPopup.vue?vue&type=template&id=5b198d12&scoped=true"
import script from "./CardPopup.vue?vue&type=script&lang=ts"
export * from "./CardPopup.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./CardPopup.vue?vue&type=style&index=0&id=5b198d12&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5b198d12",
  null
  ,true
)

export default component.exports